import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

import { ORDER_TYPE_OPTIONS, ORDER_TYPES } from "../../constants/orders";
import { HubHookFormSelect, StationHookFormSelect } from "../../components";

import { ShipmentHookFormSelect } from "../../components/ShipmentHookFormSelect";

const PurchaseOrderOrderDetails = ({ id, disabled }) => {
  const [_, setSearchParams] = useSearchParams();

  const { watch } = useFormContext();
  const type = watch("type") || ORDER_TYPES.MATERIALS;
  const orderType = ORDER_TYPE_OPTIONS.find(({ id }) => id === type);

  const setShipmentHelper = (e, item, shipmentId) =>
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      shipmentId
        ? newParams.set("shipmentId", shipmentId)
        : newParams.delete("shipmentId");
      return newParams;
    });

  return (
    <Stack width="100%" gap="5px">
      <Typography variant="boldCaptionMain">
        Purchase Order Order Settings
      </Typography>
      <Stack gap="15px">
        <HubHookFormSelect
          name="type"
          label="Order Type"
          options={ORDER_TYPE_OPTIONS.filter((f) => f.isOutbound)}
          defaultValue={ORDER_TYPES.PROCESSING}
          disabled={disabled || id}
          shouldUnregister={false}
          required
        />
        {orderType?.requireShipment && (
          <ShipmentHookFormSelect
            name="shipmentId"
            label="Shipment"
            disabled={disabled}
            useDefault={false}
            onChange={setShipmentHelper}
            required={false}
          />
        )}
        {orderType?.isService && (
          <StationHookFormSelect
            label="Service"
            name="stationId"
            required
            department={6}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default PurchaseOrderOrderDetails;
